module.exports = __webpack_public_path__ + "img/floors-buttons-add.3e28872f.svg";